import React from 'react'
import PropTypes from 'prop-types'
import DynamicImage from '@app/components/dynamic-image'

/**
 * Renders a payment icon for the PDC Footer using a dynamic image component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.paymentIcon - The payment icon object containing image data (e.g., URL).
 * @param {string} props.name - The accessible name for the payment icon, used as the image alt text.
 * @param {Object} [props.custom] - Optional custom configuration object.
 * @param {Object} [props.custom.paymentIcon] - Optional custom payment icon configuration.
 * @param {string} [props.custom.paymentIcon.disBaseLink] - Optional custom base link for the payment icon image.
 *
 * @returns {JSX.Element|null} The rendered payment icon image, or null if no payment icon is provided.
 *
 * @example
 * <PDCFooterPaymentIcon
 *   paymentIcon={{ url: 'https://example.com/icon.png' }}
 *   name="Visa"
 *   custom={{ paymentIcon: { disBaseLink: 'https://cdn.example.com/icons/visa.png' } }}
 * />
 */
export const PDCFooterPaymentIcon = ({paymentIcon, name, custom}) => {
    return (
        <>
            {paymentIcon && (
                <DynamicImage
                    src={`${custom?.paymentIcon?.disBaseLink || paymentIcon?.url}[?sw={width}]`}
                    widths={[32]}
                    imageProps={{
                        width: '32px',
                        loading: 'lazy',
                        alt: name,
                        objectFit: 'contain'
                    }}
                />
            )}
        </>
    )
}

PDCFooterPaymentIcon.propTypes = {
    paymentIcon: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    custom: PropTypes.object
}
